import { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { ADMIN_EMAIL, SITE_URL } from '../../config';
import { auth, db } from '../../firebase';
import AdminLogin from './AdminLogin';

function AdminGate({ children }) {
  const [ready, setReady] = useState(false);
  const [user, setUser] = useState(null);
  const canonicalUrl = `${SITE_URL}/admin`;

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setReady(true);
    });
    return () => unsub();
  }, []);

  const isAdmin = useMemo(() => {
    const email = user?.email ? String(user.email).toLowerCase() : '';
    return !!email && email === String(ADMIN_EMAIL).toLowerCase();
  }, [user]);

  useEffect(() => {
    // Optional: store admin identity (NO password) in Firestore for auditing.
    // This will only succeed once your Firestore rules allow it.
    if (!ready || !user || !isAdmin) return;

    const uid = user.uid;
    if (!uid) return;

    setDoc(
      doc(db, 'adminUsers', uid),
      {
        email: user.email || '',
        lastLoginAt: serverTimestamp(),
      },
      { merge: true }
    ).catch(() => {
      // ignore if rules disallow; admin panel still works
    });
  }, [isAdmin, ready, user]);

  if (!ready) {
    return (
      <section className="content-card">
        <Helmet>
          <title>Admin – IGAMINGSPOT</title>
          <link rel="canonical" href={canonicalUrl} />
          <meta name="robots" content="noindex,nofollow" />
        </Helmet>
        <p className="secondary-text">Loading…</p>
      </section>
    );
  }

  if (!user) {
    return (
      <>
        <Helmet>
          <title>Admin – IGAMINGSPOT</title>
          <link rel="canonical" href={canonicalUrl} />
          <meta name="robots" content="noindex,nofollow" />
        </Helmet>
        <AdminLogin />
      </>
    );
  }

  if (!isAdmin) {
    return (
      <section className="content-card">
        <Helmet>
          <title>Admin – IGAMINGSPOT</title>
          <link rel="canonical" href={canonicalUrl} />
          <meta name="robots" content="noindex,nofollow" />
        </Helmet>
        <div className="content-card-header">
          <div>
            <div className="section-title">Admin</div>
            <h1 className="section-subtitle">Access denied</h1>
          </div>
          <button type="button" className="header-outline-button" onClick={() => signOut(auth)}>
            Logout
          </button>
        </div>
        <p className="secondary-text">
          This account is not allowed to access the admin panel.
        </p>
      </section>
    );
  }

  return (
    <div>
      <Helmet>
        <title>Admin – IGAMINGSPOT</title>
        <link rel="canonical" href={canonicalUrl} />
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button type="button" className="header-outline-button" onClick={() => signOut(auth)}>
          Logout
        </button>
      </div>
      {children}
    </div>
  );
}

export default AdminGate;


